module.exports = __webpack_public_path__ + "static/media/JILI-SLOT-029.4b7e1462.jpeg";